export const selectPipelineByOwnerData = (state) =>
  state.capture.pipelineByOwner.data;

export const selectPipelineByOwnerLoading = (state) =>
  state.capture.pipelineByOwner.isLoading;

export const selectPipelineByOwnerError = (state) =>
  state.capture.pipelineByOwner.error;
